import React, { useState, useEffect, useRef } from "react";
import { Button, Modal } from "antd";
import { useNavigate, useParams, useBlocker } from "react-router-dom";
import "./evaluationsQuestionsCardList.scss";
import QSetCandidateExamCard from "../qsetcandidateExamCard";
import useQSetStore from "../../store/qset.store";
import CandidateAssessmentModal from "../candidateAssessmentModal";
import FaceDetection from "../faceDetection";
import { API_URL } from "../../helper/axioscontants";

export default function QsetCandidateExamCardList() {
  const qsetUserDetails = JSON.parse(localStorage.getItem("qsetUserDetails"));

  const navigate = useNavigate();
  const videoRef = useRef(null);
  const {
    myEvals,
    myQuestions,
    sendEvalAnswers,
    updateEvalStatus,
    getMyEval,
    getMyApplication,
  } = useQSetStore();
  const [questionIndex, setQuestionIndex] = useState(0);
  const numbers = Array.from(
    { length: myQuestions?.[0]?.qdescarray?.length },
    (_, i) => i + 1,
  );

  const [evalDesc, setEvalDesc] = useState({});
  const [quesDesc, setQuesDesc] = useState([]);
  const [ansDesc, setAnsDesc] = useState([]);
  const [changesSave, setChangesSave] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [timeLeft, setTimeLeft] = useState(60 * 60 - 1);
  const [examFinished, setExamFinished] = useState(false);
  const [isAssessmentActive, setAssessmentActive] = useState(false);
  const [allowLeave, setAllowLeave] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);
  const isManualFinishRef = useRef(false);

  //Camera useStates
  const [stream, setStream] = useState(null);

  //Warning Modal for assessment
  const [isModalOpen, setIsModalOpen] = useState({
    fullScreenWarning: false,
    fullScreenWarningCount: {
      outOfFocusWarningCount: 0,
      minBrowserWarningCount: 0,
    },
    faceDetectionWarning: false,
    faceDetectionWarningCount: {
      noFaceWarningCount: 0,
      multiFacesWarningCount: 0,
    },
    faceReacquired: false,
  });

  const { ev_id } = useParams();

  useEffect(() => {
    const handlePopState = (e) => {
      if (!allowLeave) {
        e.preventDefault();
        setShowConfirm(true); // show confirmation modal
        window.history.pushState(null, "", window.location.href); // prevent going back
      }
    };

    window.history.pushState(null, "", window.location.href);
    window.addEventListener("popstate", handlePopState);

    return () => {
      window.removeEventListener("popstate", handlePopState);
    };
  }, [allowLeave]);

  // Synchronous store
  const modalStateRef = useRef(isModalOpen);

  // Exam Timer Ref
  const endTimeRef = useRef(null);

  // Keep ref in sync with state
  useEffect(() => {
    modalStateRef.current = isModalOpen;
  }, [isModalOpen]);

  useEffect(() => {
    startExam();
  }, []);

  const toggleModal = (type, subType, value) => {
    setIsModalOpen((prevObj) => {
      if (type === "fullScreenWarning") {
        return {
          ...prevObj,
          fullScreenWarning: value,
          fullScreenWarningCount:
            subType === "outOfFocusWarning"
              ? {
                  ...prevObj.fullScreenWarningCount,
                  outOfFocusWarningCount: value
                    ? prevObj.fullScreenWarningCount.outOfFocusWarningCount + 1
                    : prevObj.fullScreenWarningCount.outOfFocusWarningCount,
                }
              : {
                  ...prevObj.fullScreenWarningCount,
                  minBrowserWarningCount: value
                    ? prevObj.fullScreenWarningCount.minBrowserWarningCount + 1
                    : prevObj.fullScreenWarningCount.minBrowserWarningCount,
                },
        };
      } else if (type === "faceDetectionWarning") {
        return {
          ...prevObj,
          faceDetectionWarning: value,
          faceReacquired: false,
          faceDetectionWarningCount:
            subType === "noFaceWarning"
              ? {
                  ...prevObj.faceDetectionWarningCount,
                  noFaceWarningCount: value
                    ? prevObj.faceDetectionWarningCount.noFaceWarningCount + 1
                    : prevObj.faceDetectionWarningCount.noFaceWarningCount,
                }
              : {
                  ...prevObj.faceDetectionWarningCount,
                  multiFacesWarningCount: value
                    ? prevObj.faceDetectionWarningCount.multiFacesWarningCount +
                      1
                    : prevObj.faceDetectionWarningCount.multiFacesWarningCount,
                },
        };
      } else if (type === "faceReacquired") {
        // Just flips the flag - doesn't touch the open/closed state of the
        // modal or any violation counts. Used so the warning modal can
        // freeze its countdown while the candidate's face is back in
        // frame, giving them a moment to actually read the warning.
        return {
          ...prevObj,
          faceReacquired: value,
        };
      }
      return prevObj;
    });
  };

  useEffect(() => {
    var eDesc = myEvals?.evals?.filter((item) => item.qhevid == ev_id);
    if (eDesc?.[0] != null) {
      setEvalDesc(eDesc[0]);
    }
    var qArr = myQuestions?.filter((item) => item.qhevid == ev_id);
    if (qArr?.[0]?.qdescarray != null) {
      setQuesDesc([...qArr[0]?.qdescarray]);
      console.log("These are the questions", qArr[0]?.qdescarray);
      //init the answer

      var anItemArray = [];
      for (let idx = 0; idx < qArr[0]?.qdescarray?.length; idx++) {
        var ansItem = {};
        ansItem.localStatus = "Not Given";
        ansItem.question = qArr[0].qdescarray[idx].question;
        ansItem.questionid = qArr[0].qdescarray[idx].ID;
        ansItem.questiontype = qArr[0].qdescarray[idx].questiontype;
        ansItem.output = qArr[0].qdescarray[idx].output;
        ansItem.code = "";
        ansItem.inputanswer = "";
        ansItem.mark = 0;
        ansItem.correctanswer = qArr[0].qdescarray[idx].answer;
        ansItem.saveStatus = false;
        anItemArray.push(ansItem);
      }
      setAnsDesc([...anItemArray]);
      //console.log("Initializtion Answer array",anItemArray)
    }

    if (currentPage != 1) {
      setCurrentPage(1);
    }
  }, [myEvals, myQuestions]);

  useEffect(() => {
    getMyEval(qsetUserDetails.sessionid);
    getMyApplication(qsetUserDetails.sessionid);
    console.log("These are myEvals", myEvals);
    console.log("These are myQuestions", myQuestions);

    //getMyoffer()
  }, []);

  // useEffect(() => {
  //   let timer;

  //   const handleBeforeUnload = (event) => {
  //     event.preventDefault();

  //     // Start timer if not already running
  //     if (!window.__reloadTimerRunning) {
  //       window.__reloadTimerRunning = true;

  //       const endTime = Date.now() + 10 * 1000;

  //       timer = setInterval(async () => {
  //         const diff = Math.max(0, Math.floor((endTime - Date.now()) / 1000));

  //         if (diff <= 0) {
  //           clearInterval(timer);
  //           window.__reloadTimerRunning = false;
  //           await handleFinish("Proctoring Fail maxBrowser");
  //           navigate("/qsethome/qsetdashboard");
  //         }
  //       }, 500);
  //     }

  //     // 👇 Extra safeguard: if user pressed Cancel (stayed on page),
  //     // we clear the timer immediately when unload was prevented
  //     setTimeout(() => {
  //       if (window.__reloadTimerRunning) {
  //         clearInterval(timer);
  //         window.__reloadTimerRunning = false;
  //         console.log("User cancelled reload → timer cleared.");
  //       }
  //     }, 0);
  //   };

  //   window.addEventListener("beforeunload", handleBeforeUnload);

  //   return () => {
  //     window.removeEventListener("beforeunload", handleBeforeUnload);
  //     clearInterval(timer);
  //   };
  // }, [navigate]);

  // Timer
  useEffect(() => {
    if (!endTimeRef.current) {
      endTimeRef.current = Date.now() + timeLeft * 1000; // store absolute end time
    }

    const timer = setInterval(() => {
      if (!endTimeRef.current) return;

      const diff = Math.max(
        0,
        Math.floor((endTimeRef.current - Date.now()) / 1000),
      );
      setTimeLeft(diff);

      if (diff <= 0) {
        clearInterval(timer);
        setExamFinished(true);
      }
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  // Camera setup

  // Focus & fullscreen handling
  useEffect(() => {
    setAssessmentActive(true);
    let focusLostTime;

    const handleBlur = () => {
      toggleModal("fullScreenWarning", "outOfFocusWarning", true);

      if (
        modalStateRef.current.fullScreenWarningCount.outOfFocusWarningCount +
          modalStateRef.current.fullScreenWarningCount.minBrowserWarningCount >=
        3
      ) {
        setTimeout(() => {
          handleFinish("Proctoring Fail OutBrowser");
        }, 3000);
        return;
      }
    };

    const handleFullscreenChange = () => {
      if (!document.fullscreenElement) {
        toggleModal("fullScreenWarning", "minBrowserWarning", true);
        if (
          modalStateRef.current.fullScreenWarningCount.outOfFocusWarningCount +
            modalStateRef.current.fullScreenWarningCount
              .minBrowserWarningCount >
          3
        ) {
          setTimeout(() => {
            handleFinish("Proctoring Fail MaxBrowser");
          }, 5000);
        }
      } else {
        toggleModal("fullScreenWarning", null, false);
      }
    };

    window.addEventListener("blur", handleBlur);
    // window.addEventListener("focus", handleFocus);
    document.addEventListener("fullscreenchange", handleFullscreenChange);

    return () => {
      window.removeEventListener("blur", handleBlur);
      // window.removeEventListener("focus", handleFocus);
      document.removeEventListener("fullscreenchange", handleFullscreenChange);
    };
  }, []);

  const itemsPerPage = 15;
  const handlePageChange = (page) => {
    if (page !== currentPage) {
      setCurrentPage(page);
      console.log("Showing the current page", page);
    }
    //rdbResumeSearchPerPage();
  };

  const handleSaveAndUpdate = (value) => {
    const jasonValues = encodeJson();
    sendEvalAnswers({ jasonValues, ev_id });
    setChangesSave(false);
  };

  const handleFinish = async (value) => {
    //first save any pending answers
    var jasonValues = encodeJson();
    await sendEvalAnswers({ jasonValues, ev_id });

    //now update the status
    jasonValues = encodeJsonFinish(value);

    await updateEvalStatus({ jasonValues, ev_id });
    isManualFinishRef.current = true;
    setChangesSave(false);

    //go to home dashboard
    navigate("/qsethome/qsetdashboard");
  };

  const handleTimeout = (value) => {
    //first save any pending answers
    var jasonValues = encodeJson();
    sendEvalAnswers({ jasonValues, ev_id });

    //now update timeout status
    jasonValues = encodeJsonTimeout();
    updateEvalStatus({ jasonValues, ev_id });
    setChangesSave(false);
  };

  const handleStart = () => {
    var jasonValues = encodeJsonStartExam();
    updateEvalStatus({ jasonValues, ev_id });
  };

  //get the time
  function getTimeNow() {
    const today = new Date();
    const month = today.getMonth() + 1;
    const year = today.getFullYear();
    const date = today.getDate();
    const currentDate = date + "-" + month + "-" + year;
    return currentDate;
  }

  const getAnswerMark = (index, id) => {
    if (index === parseInt(quesDesc[id].answer)) {
      return 1;
    } else {
      return 0;
    }
  };
  const handlerSavedHanlder = (idx) => {
    return ansDesc[idx]?.saveStatus;
  };
  const encodeJson = () => {
    var qsetUserData = JSON.parse(localStorage.getItem("qsetUserDetails"));
    let encodedJsonValues = {};

    //encodedJsonValues.qhcompanyjid =;
    encodedJsonValues.qhoid = qsetUserData.qhoid;
    encodedJsonValues.qhevid = evalDesc.qhevid;
    encodedJsonValues.takendate = getTimeNow();
    console.log("ans dec", ansDesc);

    encodedJsonValues.aset = [];
    for (let idx = 0; idx < ansDesc?.length; idx++) {
      if (ansDesc[idx].localStatus != "Not Given") {
        var ans = {};
        ans.questionid = ansDesc[idx].questionid;
        ans.question = ansDesc[idx].question;
        ans.questiontype = ansDesc[idx].questiontype;
        ans.selectedoption = ansDesc[idx].option;
        ans.inputanswer = ansDesc[idx].inputanswer;
        ans.codeinput = ansDesc[idx].code;
        ans.codeoutput = ansDesc[idx].output;
        if (
          ansDesc[idx].questiontype == "Multiple Choice" ||
          ansDesc[idx].questiontype == "Multiple Choice Code"
        ) {
          ans.mark = getAnswerMark(ans.selectedoption, idx);
          ans.correctanswer = ansDesc[idx].correctanswer;
        }
        encodedJsonValues.aset.push(ans);
        ansDesc[idx].saveStatus = true;
        setAnsDesc([...ansDesc]);
      }
    }
    console.log("Encoded Json", encodedJsonValues);
    return encodedJsonValues;
  };

  const encodeJsonFinish = (value) => {
    var qsetUserData = JSON.parse(localStorage.getItem("qsetUserDetails"));
    let encodedJsonValues = {};

    //encodedJsonValues.qhcompanyjid =;
    encodedJsonValues.qhoid = qsetUserData.qhoid;
    encodedJsonValues.qhevid = evalDesc.qhevid;
    encodedJsonValues.takendate = getTimeNow();
    encodedJsonValues.status = "Proctoring Fail";

    if (value === "Proctoring Camera Not Started") {
      encodedJsonValues.proctoringfailreason = "Proctoring Camera Not Started";
    } else if (value === "Proctoring Fail Many") {
      encodedJsonValues.proctoringfailreason = "Proctoring Fail Many";
    } else if (value === "Proctoring Fail OutBrowser") {
      encodedJsonValues.proctoringfailreason = "Proctoring Fail OutBrowser";
    } else if (value === "Proctoring Fail Empty Video") {
      encodedJsonValues.proctoringfailreason = "Proctoring Fail Empty Video";
    } else if (value === "Proctoring Fail maxBrowser") {
      encodedJsonValues.proctoringfailreason = "Proctoring Fail maxBrowser";
    } else {
      encodedJsonValues.status = "Completed";
    }
    console.log("Encoded Json", encodedJsonValues);
    return encodedJsonValues;
  };
  const encodeJsonTimeout = () => {
    var qsetUserData = JSON.parse(localStorage.getItem("qsetUserDetails"));
    let encodedJsonValues = {};

    //encodedJsonValues.qhcompanyjid =;
    encodedJsonValues.qhoid = qsetUserData.qhoid;
    encodedJsonValues.qhevid = evalDesc.qhevid;
    encodedJsonValues.takendate = getTimeNow();
    encodedJsonValues.status = "Timeout";

    console.log("Encoded Json", encodedJsonValues);
    return encodedJsonValues;
  };

  const formatTime = (seconds) => {
    const m = Math.floor(seconds / 60)
      .toString()
      .padStart(2, "0");
    const s = (seconds % 60).toString().padStart(2, "0");
    return `${m}:${s}`;
  };

  const encodeJsonStartExam = (value) => {
    var qsetUserData = JSON.parse(localStorage.getItem("qsetUserDetails"));
    let encodedJsonValues = {};

    //encodedJsonValues.qhcompanyjid =;
    encodedJsonValues.qhoid = qsetUserData.qhoid;
    encodedJsonValues.qhevid = evalDesc.qhevid;
    encodedJsonValues.takendate = getTimeNow();
    encodedJsonValues.status = "Ongoing";

    return encodedJsonValues;
  };

  const startExam = async () => {
    try {
      await document.documentElement.requestFullscreen();
      const cameraStream = await navigator.mediaDevices.getUserMedia({
        video: true,
      });
      if (videoRef.current) {
        videoRef.current.srcObject = cameraStream;
      }
      setStream(cameraStream); // Save the stream object to state
      handleStart();
    } catch (err) {
      console.error("Permission check failed or fullscreen denied", err);
      if (
        err.name === "NotAllowedError" ||
        err.name === "SecurityError" ||
        err.name === "AbortError"
      ) {
        alert(
          "Camera and/or fullscreen permission was denied. Please check your browser settings and try again.",
        );
      }
    }
  };

  function updateEvalStatusUnload(ev_id, jasonValues) {
    try {
      const qsetUserData = JSON.parse(
        localStorage.getItem("qsetUserDetails") || "{}",
      );
      if (!qsetUserData || !qsetUserData.sessionid) return;

      const url = `${API_URL}/qsetEvalSetUpdateStatus/${qsetUserDetails.sessionid}/${qsetUserDetails.qhoid}/${qsetUserDetails.qhrid}/${qsetUserDetails.qhcompanyjid}/${ev_id}`;

      // Prepare payload exactly like your normal call expects
      const payload = JSON.stringify(jasonValues);

      // sendBeacon accepts either a string, ArrayBufferView, Blob or FormData.
      // Use a Blob with application/json type so backend sees JSON content-type.
      const blob = new Blob([payload], { type: "application/json" });

      // This returns true/false; no response body is available
      const ok = navigator.sendBeacon(url, blob);
      // optional: log or ignore
      // console.log("sendBeacon ok:", ok);
    } catch (err) {
      // best-effort; don't block unload
      console.error("updateEvalStatusUnload failed:", err);
    }
  }

  // The Cleanup Hook
  useEffect(() => {
    // This return function runs when the component unmounts.
    return () => {
      console.log("Cleaning up camera stream...");
      // Check if a stream was successfully captured and saved to state
      if (stream) {
        // Iterate through all tracks and stop each one
        stream.getTracks().forEach((track) => {
          track.stop();
        });
        console.log("Camera stream stopped.");
      }
    };
  }, [stream]);

  useEffect(() => {
    const handleBeforeUnload = (e) => {
      e.preventDefault();
      e.returnValue = ""; // Shows the warning dialog
    };

    window.addEventListener("beforeunload", handleBeforeUnload);
    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, []);

  // 2. If user confirms refresh → update backend using keepalive
  useEffect(() => {
    const handleVisibility = () => {
      if (document.visibilityState === "hidden") {
        // if finish was not performed manually
        if (!isManualFinishRef.current) {
          // create the minimal jasonValues you need for status update
          const jasonValues = encodeJsonFinish("Proctoring Fail OutBrowser"); // or whatever format you use
          updateEvalStatusUnload(ev_id, jasonValues);
        }
      }
    };

    document.addEventListener("visibilitychange", handleVisibility);
    return () =>
      document.removeEventListener("visibilitychange", handleVisibility);
  }, []);

  // 3. On mount (after refresh) → check status and redirect
  useEffect(() => {
    async function checkStatus() {
      console.log("Checking status...");
      try {
        await getMyEval(qsetUserDetails.sessionid);
        const updatedEvals = useQSetStore.getState().myEvals;
        const currentEvaluation = updatedEvals?.evals?.find(
          (item) => item.qhevid == ev_id,
        );
        if (
          currentEvaluation.status === "Proctoring Fail" ||
          currentEvaluation.status === "Completed"
        ) {
          navigate("/qsethome/qsetdashboard");
        }
      } catch (err) {
        console.error("Status check failed:", err);
      }
    }

    checkStatus();
  }, [navigate]);

  return (
    <div className="qset-evaluationsQuestionsCardList-wrapper">
      <CandidateAssessmentModal
        isModalOpen={isModalOpen}
        toggleModal={toggleModal}
        handleFinish={handleFinish}
      />

      <>
        <div className="qset-evaluationsQuestionsCardList-Top">
          <div className="resumeResultsCardList-buttons">
            <Button onClick={() => handleFinish()}>Finish Test</Button>
            {changesSave ? (
              <>
                <div className="resumeResultsCardList-buttons">
                  <Button onClick={() => handleSaveAndUpdate()}>
                    Save and Update
                  </Button>
                </div>
              </>
            ) : (
              <>
                <div className="resumeResultsCardList-buttons">
                  <Button disabled>Save and Update</Button>
                </div>
              </>
            )}
          </div>
          <div
            className="resumeResultsCardList-buttons"
            style={{ marginRight: "20px", paddingRight: "10px" }}
          >
            <Button onClick={() => handleTimeout()}>
              {formatTime(timeLeft)} Mins
            </Button>
          </div>
        </div>
        <div style={{ marginTop: "20px", padding: "10px" }}>
          {<h3 className="eval-title">{evalDesc.name}</h3>}
        </div>
        <div className="candidate-assessment-container">
          <div className="candidate-assessment-container-left">
            <div className="candidate-assessment-map">
              {numbers.map((number) => {
                const index = number - 1;
                const isActive = questionIndex === index;

                // Determine if the question has been answered
                const isAnswered =
                  ansDesc &&
                  ansDesc[index] &&
                  (ansDesc[index].localStatus !== "Not Given" ||
                    ansDesc[index].inputanswer !== "" ||
                    ansDesc[index].code !== "" ||
                    ansDesc[index].saveStatus === true);

                return (
                  <button
                    key={number}
                    className="candidate-assessment-map-btn"
                    style={{
                      backgroundColor: isActive
                        ? "#3b82f6" // Active / Selected question (Blue)
                        : isAnswered
                          ? "#16a34a" // Answered question (Green)
                          : "", // Unanswered / Default
                      color: isActive || isAnswered ? "#ffffff" : "", // Ensures text is readable on colored backgrounds
                    }}
                    onClick={() => setQuestionIndex(index)}
                  >
                    {number}
                  </button>
                );
              })}
            </div>
          </div>
          <div className="candidate-assessment-container-right">
            <div style={{ margin: "2px", padding: "20px" }}>
              <QSetCandidateExamCard
                index={questionIndex}
                evalDesc={evalDesc}
                localQDesc={quesDesc}
                localADesc={ansDesc}
                ansHandler={setAnsDesc}
                changeHandler={setChangesSave}
                isSavedHandler={handlerSavedHanlder}
              />
            </div>
            <div className="candidate-assessment-left-footer">
              <div className="candidate-assessment-footer-left">
                <Button
                  className="candidate-assessment-footer-left-button"
                  onClick={() =>
                    questionIndex > 0 && setQuestionIndex(questionIndex - 1)
                  }
                >
                  Previous
                </Button>
                <Button
                  className="candidate-assessment-footer-left-button"
                  onClick={() =>
                    questionIndex < myQuestions[0]?.qdescarray?.length - 1 &&
                    setQuestionIndex(questionIndex + 1)
                  }
                >
                  Next
                </Button>
              </div>
            </div>
          </div>
        </div>
      </>

      <Modal
        title="Exam Finished"
        open={examFinished}
        onOk={() => {
          setExamFinished(false);
          navigate("/qsethome/qsetdashboard");
        }}
        onCancel={() => {
          setExamFinished(false);
          navigate("/qsethome/qsetdashboard");
        }}
        footer={[
          <Button
            type="primary"
            key="ok"
            onClick={() => {
              setExamFinished(false);
              navigate("/qsethome/qsetdashboard");
            }}
          >
            OK
          </Button>,
        ]}
      >
        <p>Your exam time is over. Please submit your answers.</p>
      </Modal>

      {/* <video
          ref={videoRef}
          autoPlay
          playsInline
          className="rounded-2xl shadow-lg border border-gray-300"
          style={{
            width: "250px",
            height: "150px",
            objectFit: "cover",
            borderRadius: "15px",
          }}
        /> */}
      <video
        ref={videoRef}
        autoPlay
        playsInline
        style={{ display: "none" }}
      ></video>

      <div className="evalutation-camera">
        <FaceDetection
          isModalOpen={isModalOpen}
          toggleModal={toggleModal}
          modalStateRef={modalStateRef}
          handleFinish={handleFinish}
          videoRef={videoRef}
          onCameraReady={() => {
            console.log("Camera is ready, starting face detection.");
            // You can call a function here if needed
          }}
        />
      </div>
    </div>
  );
}
